import React from 'react';
import PropTypes from 'prop-types';

import FieldContentTaxonomy from 'src/components/FieldContentTaxonomy';
import { useStyles } from './useStyles';

export const TaxonomyForm = ({ value, onChange, error }) => {
  const styles = useStyles();

  return (
    <FieldContentTaxonomy
      className={styles.fieldTaxonomy}
      value={value}
      onChange={onChange}
      error={error}
      hideLabel
    />
  );
};

TaxonomyForm.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

TaxonomyForm.defaultProps = {
  value: '',
  error: false,
};
